import { useUpdateReviewableOrder } from '@src/orders/hooks/useReviewableOrder';
import { OrderInvoicesClient } from '@src/orders/services/OrderInvoiceClient';
import { useMutation } from '@tanstack/react-query';

export const useUpdateAdminFeeRate = ({ orderId }: { orderId: string }) => {
  const { updateReviewableOrder } = useUpdateReviewableOrder();
  const { mutate: updateAdminFeeRate, isPending } = useMutation({
    mutationFn: ({ adminFeeRate }: { adminFeeRate: number }) =>
      OrderInvoicesClient.updateAdminFeeRate({
        orderId,
        adminFeeRate,
      }),
    onSuccess: (updatedOrder) => {
      updateReviewableOrder({ updatedOrder });
    },
  });

  return {
    updateAdminFeeRate,
    isPending,
  };
};
